import "./static/donate_bg.jpg";

import "./donate_now.css";
